import { GrantAccess } from 'components/GrantAccess';
import { PermissionsEnum } from 'model/User';
import { WorkcellsList } from 'screens/WorkcellsScreen/WorkcellsList';

export default function WorkcellsPage() {
  return (
    <GrantAccess permissionsNeeded={PermissionsEnum.RUN_RESOURCES}>
      <WorkcellsList />
    </GrantAccess>
  );
}
